'use client';

import React, { useCallback, useEffect, useState } from 'react';
import { ErrorBoundary } from 'next/dist/client/components/error-boundary';

interface ErrorFallbackProps {
  id: string;
}

function ErrorFallback({ id }: ErrorFallbackProps) {
  const [image, setImage] = useState<string | null>(null);

  useEffect(() => {
    const url = new URL(window.location.href);
    const fullUrl = url.toString();
    const { origin } = url;
    setImage(`${origin}/error-boundary-fallback?id=${id}&url=${fullUrl}`);
  }, [id]);

  // eslint-disable-next-line @next/next/no-img-element
  return image ? <img src={image} alt="" style={{ display: 'none' }} /> : null;
}

interface TrackedErrorBoundaryProps {
  id: string;
  children: React.ReactNode;
}

export default function TrackedErrorBoundary({ id, children }: TrackedErrorBoundaryProps) {
  const ErrorFallbackComponent = useCallback(() => <ErrorFallback id={id} />, [id]);
  return <ErrorBoundary errorComponent={ErrorFallbackComponent}>{children}</ErrorBoundary>;
}
